<template>
  <div class="Xdropdownfilter">
    <select v-model="Filter" @change="$emit('input', $event.target.value)" class="form-control">
      <option value></option>
      <option v-for="(option, index) in options" :key="index" v-bind:value="option.value">{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
'use strict'
import { EventBus } from 'pevueglobal'
export default {
  props: {
    options: {
      type: Array,
      default: () => {
        return []
      },
    },
    name: {
      type: String,
    },
    value: {
      default: '',
    },
  },
  data() {
    return {
      filtervalue: '',
      keuzeText: '',
      type: 'dropdown',
    }
  },
  mounted: function () {
    EventBus.$on('FilterDeleted', (filter) => {
      if (filter.name === this.name) {
        this.keuzeText = ''
        this.Filter = ''
      }
    })
  },
  methods: {},
  computed: {
    Filter: {
      get: function () {
        return this.filtervalue
      },
      set: function (value) {
        this.filtervalue = value
        if (value === '') {
          this.keuzeText = ''
          this.$store.commit('deleteFilter', this.name)
        } else {
          var values = this.options.map(function (o) {
            return o.value
          })
          var index = values.indexOf(this.filtervalue)
          this.keuzeText = this.options[index].text
          this.$store.commit('setFilter', {
            type: this.type,
            name: this.name,
            value: this.filtervalue,
            text: this.keuzeText,
          })
        }

        // this.$emit('updateFilter')
      },
    },
  },
}
</script>
